import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { StockService } from '@pedix-workspace/pedixapp-stock';
import { Product } from '@pedix-workspace/utils';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'pxwSortProductsByStock',
  standalone: true,
})
export class SortProductsByStockPipe<
  T extends Pick<Product, 'id' | 'presentations'>,
> implements PipeTransform {
  private stockService = inject(StockService);

  transform(products: T[]): T[] {
    return [...products].sort((productA, productB) => {
      if (this.isWithoutStock(productA)) {
        return 1;
      }
      return this.isWithoutStock(productB) ? -1 : 0;
    });
  }

  private isWithoutStock(product: T): boolean {
    return this.stockService.isProductWithoutStock({
      id: product.id,
      presentationItems: product.presentations?.items,
    });
  }
}
